export function findAndExecute<T extends { id: number }>(
  array: T[],
  id: number,
  callback: (item: T) => void
) {
  const item = array.find((item) => item.id === id);
  if (item && callback) {
    callback(item);
  }
}
